<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >

    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <v-dialog
        :scrollable="true"
        persistent
        :fullscreen="true"
        v-if="$vuetify.breakpoint.smAndDown"
        v-model="dialogModel"
        @keydown.esc="dialogCancelAction"
      >
        <v-overlay :value="pageLoading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div v-if="loading">
          <v-skeleton-loader
            class="mx-auto d-none d-sm-block"
            type="article, actions"
          ></v-skeleton-loader>

          <v-skeleton-loader
            class="mx-auto d-sm-none"
            type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
          ></v-skeleton-loader>
        </div>
        <v-card v-else>
          <v-card-title>
            <span class="h4">Novo Ajuste de Estoque</span>
            <v-spacer></v-spacer>
              <v-btn
                text
                icon
                title="Cancelar"
                class="my-2"
                @click="dialogCancelAction"
              >
                <v-icon right dark>mdi-close-circle</v-icon>
              </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text id="dialogBody">

            <v-list
              :flat="false"
              :dense="false"
              class="mt-5"
            >
              <v-list-item-group
                :multiple="false"
                color="success"
              >
                
                <v-divider
                  key="divider-1"
                />
                <v-list-item
                  key="list-item-1"
                  @click="exitStorageAdjustmentOpenAction"
                  :two-line="false"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-table-minus</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="title">Ajuste de Saída</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider
                  key="divider-2"
                />
                <v-list-item
                  key="list-item-2"
                  @click="entryStorageAdjustmentOpenAction"
                  :two-line="false"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-table-plus</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="title">Ajuste de Entrada</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                
                <v-divider
                  key="divider-last"
                />
                
              </v-list-item-group>
            </v-list>

            <ExitStorageAdjustmentNew
              @entry-created="entryCreated"
              modelNameSingular="Ajuste de Saída de Estoque"
              :useModelInsteadOfButton="true"
              ref="exitStorageAdjustmentNewRef"
            />

            <EntryStorageAdjustmentNew
              @entry-created="entryCreated"
              modelNameSingular="Ajuste de Entrada de Estoque"
              :useModelInsteadOfButton="true"
              ref="entryStorageAdjustmentNewRef"
            /> 

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn class="my-2" @click="dialogCancelAction">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
        <template v-slot:activator="{ on: dialog }" @open-dialog="dialogOpenAction">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="primary"
                class="ma-1 d-none d-md-flex"
                v-on="{ ...tooltip, ...dialog }"
                @click="dialogOpenAction"
                :disabled="false">
                  Adicionar Ajuste de Estoque
                <v-icon right dark>mdi-plus</v-icon>
              </v-btn>

              <v-btn
                class="d-md-none"
                color="primary"
                absolute
                right
                fab
                v-on="{ ...dialog }"
                @click="dialogOpenAction"
                :disabled="false"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>

            </template>
            <span>Criar Ajuste de Estoque</span>
          </v-tooltip>
        </template>
      </v-dialog>

      <ExitStorageAdjustmentNew
        v-if="$vuetify.breakpoint.mdAndUp"
        @entry-created="entryCreated"
        modelNameSingular="Ajuste de Saída de Estoque"
      />

      <EntryStorageAdjustmentNew
        v-if="$vuetify.breakpoint.mdAndUp"
        @entry-created="entryCreated"
        modelNameSingular="Ajuste de Entrada de Estoque"
      />

    </template>
    
    <!-- <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <ExitStorageAdjustmentNew
        @entry-created="entryCreated"
        modelNameSingular="Ajuste de Saída de Estoque"
      />

      <EntryStorageAdjustmentNew
        @entry-created="entryCreated"
        modelNameSingular="Ajuste de Entrada de Estoque"
      />
    </template> -->


    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <ExitStorageAdjustmentEdit v-if="item.isStockEntryType == false"
        :entry="item"
        :readOnly="true"
        modelNameSingular="Ajuste de Saída de Estoque"
      />

      <EntryStorageAdjustmentEdit v-if="item.isStockEntryType == true"
        :entry="item"
        :readOnly="true"
        modelNameSingular="Ajuste de Entrada de Estoque"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <ExitStorageAdjustmentEdit v-if="item.isStockEntryType == false"
        :entry="item"
        @entry-updated="entryUpdated"
        modelNameSingular="Ajuste de Saída de Estoque"
        :isEdit="true"
      />
      
      <EntryStorageAdjustmentEdit v-if="item.isStockEntryType == true"
        :entry="item"
        @entry-updated="entryUpdated"
        modelNameSingular="Ajuste de Entrada de Estoque"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <ExitStorageAdjustmentDelete v-if="item.isStockEntryType == false"
        :entry="item"
        @entry-destroyed="entryDeleted"
        modelNameSingular="Ajuste de Saída de Estoque"
      />
      
      <EntryStorageAdjustmentDelete v-if="item.isStockEntryType == true"
        :entry="item"
        @entry-destroyed="entryDeleted"
        modelNameSingular="Ajuste de Entrada de Estoque"
      />
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import ExitStorageAdjustmentNew from "./exit_storage_adjustments/new.vue";
import ExitStorageAdjustmentEdit from "./exit_storage_adjustments/edit.vue";
import ExitStorageAdjustmentDelete from "./exit_storage_adjustments/delete.vue";
import EntryStorageAdjustmentNew from "./entry_storage_adjustments/new.vue";
import EntryStorageAdjustmentEdit from "./entry_storage_adjustments/edit.vue";
import EntryStorageAdjustmentDelete from "./entry_storage_adjustments/delete.vue";

export default {
  data() {
    return {
      dialogModel: false,
      exitStorageAdjustmentNewDialog: false,
      entryStorageAdjustmentNewDialog: false,
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        //trocar id para code depois que vier a coluna
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Data", align: "left", sortable: true, value: "date" },
        { text: "Estoque", align: "left", sortable: true, value: "storage.name" },
        { text: "Motivo", align: "left", sortable: true, value: "stockAdjustmentReason.name" },
        { text: "Tipo de Ajuste", align: "left", sortable: true, value: "adjustmentTypeText", filter_value: "isStockEntryType" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'date', mask: 'date'},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Ajuste de Estoque"
    },
    modelNamePlural: {
      type: String,
      default: "Ajustes de Estoques"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    ExitStorageAdjustmentNew: ExitStorageAdjustmentNew,
    ExitStorageAdjustmentEdit: ExitStorageAdjustmentEdit,
    ExitStorageAdjustmentDelete: ExitStorageAdjustmentDelete,
    EntryStorageAdjustmentNew: EntryStorageAdjustmentNew,
    EntryStorageAdjustmentEdit: EntryStorageAdjustmentEdit,
    EntryStorageAdjustmentDelete: EntryStorageAdjustmentDelete,
  },
  created() {
    // this.loadServerEntries();
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_STORAGE_ADJUSTMENTS,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // this.fields = response.data.groundContext.fieldsIndex.fields;
          //console.log("All fields", this.fields);
          this.indexItems = response.data.accountContext.storageAdjustmentsIndex.stockAdjustments; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.accountContext.storageAdjustmentsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.accountContext.storageAdjustmentsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.storageAdjustmentsIndex.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
    exitStorageAdjustmentOpenAction: function() {
      if (this.$refs.exitStorageAdjustmentNewRef) {
        if (this.$refs.exitStorageAdjustmentNewRef.$refs.baseNew) {
          this.$refs.exitStorageAdjustmentNewRef.$refs.baseNew.openAction();
          this.dialogCancelAction();
        }
      }
    },
    entryStorageAdjustmentOpenAction: function() {
      if (this.$refs.entryStorageAdjustmentNewRef) {
        if (this.$refs.entryStorageAdjustmentNewRef.$refs.baseNew) {
          this.$refs.entryStorageAdjustmentNewRef.$refs.baseNew.openAction();
          this.dialogCancelAction();
        }
      }
    },
    dialogOpenAction: function() {
      // console.log("dialogOpenAction");
    },
    dialogCancelAction: function() {
      // console.log("dialogCancelAction");
      this.dialogModel = false;
    },
  }
};

const LOAD_ALL_STORAGE_ADJUSTMENTS = gql `
  query($input: IndexInputObject!) {
    accountContext {
      storageAdjustmentsIndex(input: $input){
        count
        typeOperators
        serverFields      
        stockAdjustments {
          id
          code
          date
          adjustmentTypeText
          isStockEntryType
          storage {
            name
          }
          stockAdjustmentReason {
            name
          }
          canBeDeleted
          undeletabilityReasons
        }
      }
    }
  }
`;

</script>

<style scoped></style>
